import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { GroceriesQueryVariables } from '@/gql/graphql';
import type { PaginatedGroceryTypeResponse } from '@/models/grocery';

import './fragments/GroceriesRowFragment';

export const fetchGroceries = async ({
  phoneNumber,
  name,
  orderId,
  needLoveName,
  notes,
  noGoGoFeeReason,
  orderThroughIvr,
  startDate,
  endDate,
  pagination,
}: GroceriesQueryVariables): Promise<PaginatedGroceryTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query Groceries(
        $phoneNumber: String!
        $name: String
        $orderId: String
        $needLoveName: String
        $notes: String
        $noGoGoFeeReason: String
        $orderThroughIvr: Boolean
        $startDate: String
        $endDate: String
        $pagination: PaginationInputType
      ) {
        groceries(
          phoneNumber: $phoneNumber
          name: $name
          orderId: $orderId
          notes: $notes
          needLoveName: $needLoveName
          noGoGoFeeReason: $noGoGoFeeReason
          orderThroughIvr: $orderThroughIvr
          startDate: $startDate
          endDate: $endDate
          pagination: $pagination
        ) {
          rows {
            ...GroceriesRowFragment
          }
          count
        }
      }
    `),
    variables: {
      phoneNumber,
      name,
      orderId,
      needLoveName,
      notes,
      noGoGoFeeReason,
      orderThroughIvr,
      startDate,
      endDate,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.groceries;
};
